import { ChangeEvent } from 'react';
import { GetQuestionnaire } from '../../../../services/modules/questionnaire/types';

const normalizeValues = (inputName: string, actualValue: unknown): string[] => {
  let normalizedValue: string[] = [String(actualValue)];
  const [type] = inputName.split('|');
  switch (type) {
    case 'rn':
      normalizedValue = [
        (actualValue as string).replace(/\./g, '').replace(',', '.'),
      ] as string[];
      break;
    case 'em':
      normalizedValue = Object.keys(actualValue as boolean[]).filter(
        (index) => !!(actualValue as boolean[])[Number(index)],
      ) as string[];
      break;
    case 'tg':
      normalizedValue = actualValue as string[];
      break;
    default:
      normalizedValue = [String(actualValue)];
      break;
  }
  return normalizedValue;
};

type QuestionaireData = GetQuestionnaire['return']['questions'];
const removeDuplicateQuestion = (
  questions: QuestionaireData,
): QuestionaireData => {
  const uniqueQuestions = new Map<number, QuestionaireData[0]>();
  questions.forEach((question) => {
    if (!uniqueQuestions.has(question.idQuestion)) {
      uniqueQuestions.set(question.idQuestion, question);
    }
  });

  return Array.from(uniqueQuestions.values());
};

const inputNumberChange = ({ precision }: { precision: number }) => {
  return (
    ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): { formatted: string; raw: number } => {
    const rawValue = ev.target.value.replace(/\D+/g, '');
    const validateNumber = (v: string) => {
      const vParsed = Number(v.replace(/\./g, '').replace(',', '.'));
      if (Number.isNaN(vParsed)) {
        throw new Error(`Valor inválido. Deve ser um número.`);
      }
      return true;
    };

    const formatNumber = (v: string) => {
      let vParsed = Number(v);
      if (precision > 0) {
        if (String(vParsed).length <= precision) {
          vParsed = Number(`0.${String(vParsed).padStart(precision, '0')}`);
        } else {
          const intDigits = String(vParsed).slice(0, -precision);
          const fractDigits = String(vParsed).slice(-precision);
          vParsed = Number(`${intDigits}.${fractDigits}`);
        }
      }

      return {
        formatted: new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }).format(vParsed),
        raw: vParsed,
      };
    };

    if (
      ['deleteContentForward', 'deleteContentBackward'].includes(
        (ev.nativeEvent as unknown as { inputType: string }).inputType,
      )
    ) {
      validateNumber(formatNumber(rawValue).formatted);
      return formatNumber(rawValue);
    }
    validateNumber(formatNumber(rawValue).formatted);
    return formatNumber(rawValue);
  };
};

export const Helper = {
  normalizeValues,
  removeDuplicateQuestion,
  inputNumberChange,
};
